/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/common/ScanCompletionOverlay.yaml
import { StyledText } from '../../ui_v2/common/Common';
import { PartiallyConstructible } from '../../utils/utils';
/**
Configuration of the overlay to be shown after the successful scan.
*/
export class ScanCompletionOverlay extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<ScanCompletionOverlay>`} */
    constructor(source = {}) {
        super();
        /**
          A caption below the icon.
          */
        this.message = new StyledText({ text: '?completionOverlaySuccessMessage', color: '?sbColorOnPrimary' });
        /**
          Color of the icon.
          
          Default is "?sbColorOnPrimary"
          */
        this.iconColor = '?sbColorOnPrimary';
        /**
          Background color of the overlay.
          
          Default is "?sbColorSurfaceHigh"
          */
        this.overlayBackgroundColor = '?sbColorSurfaceHigh';
        /**
          Timeout in milliseconds after which the overlay is automatically dismissed.
          
          Default is 1000
          */
        this.timeout = 1000;
        if (source.message !== undefined) {
            this.message = new StyledText(source.message);
        }
        if (source.iconColor !== undefined) {
            this.iconColor = source.iconColor;
        }
        if (source.overlayBackgroundColor !== undefined) {
            this.overlayBackgroundColor = source.overlayBackgroundColor;
        }
        if (source.timeout !== undefined) {
            this.timeout = source.timeout;
        }
    }
}
//# sourceMappingURL=ScanCompletionOverlay.js.map